<template>
  <b-tooltip
    size="is-large"
    :position="tooltipPosition"
    :type="tooltipType"
    :active="!!tooltip"
    :label="tooltip">
    <a
      @click="checkPermissions(permission) ? $emit('is-click') : showPopUp()"
      :class="{'disabled': disabled}">
      <b-icon
        :type="{[iconType]: !disabled}"
        :class="{'text-access-no-permission': !checkPermissions(permission) && !disabled}"
        :icon="icon">
      </b-icon>
    </a>
  </b-tooltip>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'BtnActionIcon',
  props: {
    tooltipLabel: {
      type: String,
      default: '',
    },
    tooltipLabelDisabled: {
      type: String,
      default: '',
    },
    tooltipType: {
      type: String,
      default: 'is-primary',
    },
    tooltipPosition: {
      type: String,
      default: 'is-top',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    permission: {
      type: Object,
      required: true,
    },
    iconType: {
      type: String,
      default: 'is-primary',
    },
    icon: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    tooltip() {
      if (this.disabled && this.tooltipLabelDisabled) return this.tooltipLabelDisabled;
      return this.tooltipLabel;
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
  },
};
</script>
